skrilla.directive('lolDailyContestDetails',function() {
    return {
        templateUrl: 'directives/lolDailyContestDetails/lolDailyContestDetails.html',
        scope: {
            contest: "="
        },
        controller: function($scope, searchService, cacheService, lolContestService, objectChangeService, contestsService, modalService, currencyService, adminService){
            $scope.hasRole = adminService.hasRole;
            $scope.key = "lolContestDetails";
            $scope.open = lolContestService.openMatchesModal;
            $scope.hasChanged = objectChangeService.hasValueChanged;
            $scope.states = ["PENDING", "LIVE", "AWAITING_RESULT", "CANCELLED", "COMPLETED"];

            $scope.calculateRostersPerUser = function(){
                var data = {
                    maximumEntries: $scope.contest.maximumEntries,
                    maximumEntriesPerUser: $scope.contest.maximumEntriesPerUser,
                    minimumEntries: $scope.contest.minimumEntries
                };
                cacheService.registerObject("maximumEntries", data);
                contestsService.openRostersCalculatorModal(function(){
                    var response = cacheService.getObject("maximumEntries");
                    $scope.contest.minimumEntries = response.minimumEntries;
                    $scope.contest.maximumEntries = response.maximumEntries;
                    $scope.contest.maximumEntriesPerUser = response.maximumEntriesPerUser;
                });
            }

            $scope.isPending = function(){
                return $scope.contest && $scope.contest.publicationState === "PENDING" && $scope.contest.contestState === "PENDING";
            }

            $scope.removeMatch = function(match) {
                modalService.confirm("Are you sure you'd like to remove this match?", function() {
                    $scope.contest.matches = $scope.contest.matches.filter(function (m) {
                        return m.id != match.id;
                    });
                    cacheService.registerObject($scope.key + "Matches", $scope.contest.matches);
                    $scope.$apply();
                });
            }

            $scope.removePlaceholder = function(placeholder) {
                modalService.confirm("Are you sure you'd like to remove this match?", function() {
                    $scope.selectedPlaceholders = $scope.selectedPlaceholders.filter(function (p) {
                        return p.id != placeholder.id;
                    });
                    cacheService.registerObject("lolContestPlaceholders", $scope.selectedPlaceholders);
                    $scope.$apply();
                });
            }

            $scope.publish = function(){
                if(confirm("Are you sure you'd like to publish this contest?")){
                    searchService.post('lol/contests/daily/' + $scope.contest.contestId + '/publish', null, "Contest successfully published!").then(function(response){
                        $scope.contest.publicationState = "PUBLISHED";
                    });
                }
            }

            $scope.save = function(){
                objectChangeService.confirmChanges($scope.key, "contest").then(function(confirm) {
                    if (confirm === true && lolContestService.confirmMatches($scope.contest.matches)) { //
                        if($scope.contest.contestState === "PENDING" && $scope.contest.publicationState === "PENDING"){
                            updatePendingContest()
                        }
                        else{
                            updateLiveContest();
                        }
                    }
                });
            }

            $scope.updateState = function(){
                if(confirm("Are you sure you'd like to publish this contest?" + $scope.contest.newState)){
                    searchService.put("contests/" + $scope.contest.contestId + "/state/" + $scope.contest.newState, null, "Contest successfully updated!").then(function(response){
                        $scope.contest.contestState = $scope.contest.newState;
                    });
                }
            }

            function updateLiveContest(){
                searchService.put("contests/" + $scope.contest.contestId + "/updateMinor", $scope.contest, "Contest Updated!").then(function(response){
                    objectChangeService.registerObject($scope.key, "contest", $scope);
                });
            }

            function updatePendingContest(){
                $scope.contest.entryFee = currencyService.multiply($scope.contest.entryFee, $scope.contest.currency);
                $scope.contest.splits.forEach(function(split){split.amount = currencyService.multiply(split.amount, $scope.contest.currency);});
                $scope.contest.prizePool = currencyService.multiply($scope.contest.prizePool, $scope.contest.currency);
                $scope.contest.matchIds = lolContestService.getMatchIds($scope.contest.matches);
                $scope.contest.matchPlaceholderIds = $scope.contest.placeholders.map(function(placeholder){return placeholder.id;});
                console.log($scope.contest);
                searchService.put('lol/contests/daily/' + $scope.contest.contestId, $scope.contest, "Contest updated").then(function(response){
                    cacheService.registerObject($scope.key, $scope.contest.matches);
                    $scope.contest.entryFee = currencyService.divide($scope.contest.entryFee, $scope.contest.currency);
                    $scope.contest.splits.forEach(function(split){split.amount = currencyService.divide(split.amount, $scope.contest.currency);});
                    $scope.contest.prizePool = currencyService.divide($scope.contest.prizePool, $scope.contest.currency);
                    objectChangeService.registerObject($scope.key, "contest", $scope);
                }, function(response){
                    cacheService.registerObject($scope.key, $scope.contest.matches);
                    $scope.contest.entryFee = currencyService.divide($scope.contest.entryFee, $scope.contest.currency);
                    $scope.contest.splits.forEach(function(split){split.amount = currencyService.divide(split.amount, $scope.contest.currency);});
                    $scope.contest.prizePool = currencyService.divide($scope.contest.prizePool, $scope.contest.currency);
                });
            }

            $scope.cancel = function(){
                modalService.confirm("Are you sure you'd like to cancel this contest?", function(){
                    searchService.put('lol/contests/daily/' + $scope.contest.contestId + '/cancel', null, "Contest successfully cancelled!").then(function(response){
                        $scope.contest.state = "CANCELLED";
                    });
                });
            }

            $scope.result = function(){
                modalService.confirm("Are you sure you'd like to result this contest?", function(){
                    searchService.put('lol/contests/daily/' + $scope.contest.contestId + '/result', null, "Contest successfully resulted!").then(function(response){
                        $scope.contest.state = "COMPLETED";
                    });
                });
            }

            $scope.prizePoolAndSplits = function(){
                cacheService.registerObject("contest", $scope.contest);
                contestsService.openSplitsModal(function(){
                });
            }

            $scope.replicate = function(){
                cacheService.registerObject("lolContest", $scope.contest);
                lolContestService.openCreateModal();
            }

        }
    };
});
